import ContentLoader from "@rio-cloud/rio-uikit/ContentLoader";

const LOADER_CLASS = "display-block skeleton-on-highlight-bg";
const FIXED_LOADER_CLASS = `${LOADER_CLASS} flex-0`;

const BANNER_ICON_SIZE = 18;
const BANNER_TEXT_HEIGHT = 17;
const BANNER_TEXT_WIDTH = 240;
const DATE_LABEL_HEIGHT = 17;
const DATE_LABEL_WIDTH = 100;
const DATE_VALUE_HEIGHT = 20;
const DATE_VALUE_WIDTH = 110;
const DESCRIPTION_HEIGHT = 20;
const DESCRIPTION_WIDTH = "80%";
const SECTION_TITLE_HEIGHT = 17;
const SECTION_TITLE_WIDTH = 130;
const METRIC_LABEL_HEIGHT = 17;
const METRIC_VALUE_HEIGHT = 29;

const METRIC_LABEL_WIDTHS = [110, 80];
const METRIC_VALUE_WIDTHS = [120, 130];

export default function MaintenanceAlertDetailSkeleton() {
  return (
    <>
      <div className="display-flex flex-wrap align-items-start justify-content-between gap-15">
        <div className="flex-1-1 display-flex align-items-center gap-10 padding-10 rounded bg-white">
          <ContentLoader className={LOADER_CLASS} height={BANNER_ICON_SIZE} width={BANNER_ICON_SIZE} />
          <ContentLoader className={LOADER_CLASS} height={BANNER_TEXT_HEIGHT} width={BANNER_TEXT_WIDTH} />
        </div>
        <div className="display-flex flex-column gap-5">
          <ContentLoader className={LOADER_CLASS} height={DATE_LABEL_HEIGHT} width={DATE_LABEL_WIDTH} />
          <ContentLoader className={LOADER_CLASS} height={DATE_VALUE_HEIGHT} width={DATE_VALUE_WIDTH} />
        </div>
      </div>

      <div className="margin-top-15 padding-15 rounded border border-width-1 border-color-light bg-white">
        <ContentLoader className={LOADER_CLASS} height={DESCRIPTION_HEIGHT} width={DESCRIPTION_WIDTH} />
      </div>

      <hr className="margin-top-20 margin-bottom-0 border-color-light" />

      <span className="display-block margin-top-20">
        <ContentLoader className={LOADER_CLASS} height={SECTION_TITLE_HEIGHT} width={SECTION_TITLE_WIDTH} />
      </span>

      <div className="display-flex flex-wrap gap-10 margin-top-15">
        {METRIC_LABEL_WIDTHS.map((labelWidth, index) => (
          <div
            key={labelWidth}
            className="flex-1-1 display-flex flex-column justify-content-center gap-5 padding-15 height-80 rounded border border-width-1 border-color-light bg-white"
          >
            <ContentLoader className={FIXED_LOADER_CLASS} height={METRIC_LABEL_HEIGHT} width={labelWidth} />
            <ContentLoader
              className={FIXED_LOADER_CLASS}
              height={METRIC_VALUE_HEIGHT}
              width={METRIC_VALUE_WIDTHS[index]}
            />
          </div>
        ))}
      </div>
    </>
  );
}
